// eslint-disable-next-line @altermaind/you-shall-not-pass
import { it as assessmentsLocales } from '@/assessments/locales';
import { it as billingLocales } from '@/billing/locales';
import { it as configurationLocales } from '@/configuration/locales';
import { it as conversationLocales } from '@/conversations/locales';
import { it as coreLocales } from '@/core/locales';
import { it as creditsLocales } from '@/credits/locales';
import { it as dashboardLocales } from '@/dashboard/locales';
import { it as departmentLocales } from '@/department/locales';
import { it as departmentsLocales } from '@/departments/locales';
import { it as invitationLocales } from '@/invitation/locales';
import { it as loginLocales } from '@/login/locales';
import { it as maintenanceModeLocales } from '@/maintenanceMode/locales';
import { UserStatus } from '@/organization/state/types';
import { it as paymentsLocales } from '@/payments/locales';
import { it as peopleLocales } from '@/people/locales';
import { it as profileLocales } from '@/profile/locales';
import { it as reportsLocales } from '@/reports/locales';
import { it as settingsLocales } from '@/settings/locales';
import { it as surveysLocales } from '@/surveys/locales';
import { AccountStatus } from '@/swagger/constants/anagraphics-enums';
import { EventType } from '@/swagger/constants/credits-enums';
import { it as aiPlaygroundLocales } from '@/training/aiPlayground/locales';
import { it as documentLocales } from '@/training/documents/locales';
import { it as trainingHardSkillsLocales } from '@/training/hardSkills/locales';
import { it as quizLocales } from '@/training/quiz/locales';
import { it as trainingSoftSkillsLocales } from '@/training/softSkills/locales';
import { it as videoLocales } from '@/training/video/locales';
import { EMAIL_SUPPORT, SuccessCodes } from '../constants';
import { PlatformType } from '../constants/platformType';

export const it = {
  general: {
    menu: 'MENU',
    logout: 'Esci',
    goToLogin: 'Vai alla login',
    confirm: 'Conferma',
    documentation: 'Documentazione',
    organization: 'Organizzazione',
    platform: 'Ambiente',
    language: 'Lingua',
    switchOrganization: {
      title: 'Organizzazioni',
      nowLogged: 'In uso',
      buttonGoBack: 'Indietro',
    },
    switchPlatform: {
      title: 'In quale ambiente vuoi accedere?',
      [PlatformType.ADMIN]: 'Admin dashboard',
      [PlatformType.LEARNING]: 'Learning dashboard',
      nowLogged: 'In uso',
      buttonGoBack: 'Indietro',
      viewProfile: 'Visualizza profilo',
      creditLabel: 'crediti',
      openCreditsModal: 'Vai a !{CREDITS}!',
      openCreditsModalLabel: 'crediti',
    },
  },
  dialogLogout: {
    title: 'Esci da Slash',
    description: 'Stai per uscire da Slash.',
    confirmText: 'Confermi di voler procedere?',
    confirm: 'Esci',
    cancel: 'Annulla',
  },
  table: {
    noData: 'Nessun dato disponibile',
    noContent: 'Nessun contenuto disponibile',
    ofPages: 'di {{total}} pagine',
    selectedCount: '{{count}} selezionati',
    deselectAll: 'Deseleziona tutto',
  },
  builtWith: 'Built with',
  errorBoundary: {
    title: {
      default: 'Si è verificato un errore.',
      USER_DISABLED: 'Attenzione',
      USER_PENDING: 'Attenzione',
      POPUP_BLOCKED: 'Attenzione, pop-up bloccati dal broswer',
      LICENSE_NOT_FOUND: 'Attenzione, sembra che tu non abbia un piano attivo',
    },
    description: {
      default: 'Prova a tornare in homepage e ripartire da capo.',
      CRITICAL: 'Si è verificato un errore critico. Riprova più tardi.',
      USER_DISABLED:
        "Non sei abilitato a usare l'applicazione. Contatta l'amministratore della tua organizzazione.",
      USER_PENDING:
        'La tua registrazione è in sospeso. Controlla la tua email per completare la registrazione.',
      POPUP_BLOCKED: 'Assicurati che il tuo browser non stia bloccando i pop-ups.',
      LICENSE_NOT_FOUND:
        "Contatta altermAInd per attivare il tuo piano. \nSe hai già un piano attivo, contatta l'assistenza clienti.",
    },
    back: 'Torna in Home',
    switchOrganization: 'Vuoi cambiare organizzazione?',
    dialogSwitchOrganization: {
      title: 'Cambia organizzazione',
      description: "Seleziona un'organizzazione a cui hai accesso",
      cancel: 'Annulla',
      confirm: 'Conferma',
    },
  },
  successBoundary: {
    title: {
      default: 'Congratulazioni!',
      [SuccessCodes.REGISTRATION_COMPLETED]: 'Registrazione completata',
      [SuccessCodes.PASSWORD_RESET_COMPLETED]: 'Reset della password completato',
    },
    description: {
      default: 'Congratulazioni. Torna alla pagina di login.',
      [SuccessCodes.REGISTRATION_COMPLETED]:
        'Congratulazioni. Registrazione effettuata con successo, ora puoi effettuare il login.',
      [SuccessCodes.PASSWORD_RESET_COMPLETED]:
        'Congratulazioni. Hai resettato la tua password correttamente, ora puoi effettuare il login.',
    },
    back: 'Vai alla login',
  },
  menu: {
    homepage: 'Homepage',
    myAssessments: 'I miei assessment',
    companyStructure: 'Struttura aziendale',
    departments: 'Dipartimenti',
    people: 'Anagrafiche',
    survey: 'Assessment',
    settings: 'Impostazioni',
    training: 'Training',
    aiPlayground: 'AI Playground',
    trainingSoftSkills: 'Training Soft skills',
    trainingHardSkills: 'Training Hard skills',
    department: 'Il mio dipartimento',
    team: 'Il mio team',
    comingSoon: 'Soon',
    hardSkills: 'Hard Skills',
    reports: 'Reports',
    assessmentsReports: 'Risultati Assessment',
    trainingReports: 'Fruizione Training',
    chatBot: 'AI Assistant',
  },
  languageSelector: {
    title: 'Lingua',
  },
  goBack: {
    title: 'Indietro',
  },
  goToPublicsDocs: {
    label: 'Vai alla guida',
  },
  tableHeader: {
    filter: 'Filtra',
    search: 'Cerca...',
    add: '+',
  },
  thankYouMessage: {
    success: {
      title: 'Richiesta inviata con successo!',
      text: "Abbiamo ricevuto la tua richiesta di modifica piano. \nA breve sarà inviato il riepilogo della richiesta di ricontatto all'indirizzo email fornito.",
      cta: 'Chiudi',
    },
    error: {
      title: 'Ops, qualcosa è andato storto',
      text: 'Non siamo riusciti a inviare la tua richiesta. \nVerifica i dati inseriti e riprova. Se il problema persiste attendi qualche minuto e riprova più tardi.',
      cta: 'Riprova',
    },
  },
  headerTable: {
    new: 'Nuovo',
    filter: 'Filtra',
    search: 'Cerca...',
  },
  ctaContainer: {
    edit: 'Modifica',
    remove: 'Cancella',
    new: 'Nuovo',
    close: 'Chiudi',
    viewDetail: 'Visualizza dettagli',
    refresh: 'Aggiorna dati',
    filter: 'Filtra',
  },
  wizard: {
    nextButton: 'Avanti',
    previousButton: 'Indietro',
    skipButton: 'Salta questo step',
  },
  success: {
    genericApiSuccess: 'Operazione completata con successo',
    copyToClipboard: 'Copiato negli appunti',
  },
  warning: {
    fileTooLarge: 'Il file selezionato è troppo grande. La dimensione massima è {{maxSize}}',
  },
  errors: {
    genericApiError: "Si è verificato un'errore, riprova più tardi",
  },
  inputs: {
    placeholderSearch: 'Cerca...',
    loadMore: 'Carica altri...',
    fileInput: {
      placeholder: 'Clicca qui o trascina per aggiungere il file',
      maxFileSizeDescription: 'Massimo {{size}} supportati.',
      supportFilesDescription: 'Sono supportati i formati: {{formats}}',
      errors: {
        maxFileSize:
          'Non è stato possibile caricare il file. Verifica che la dimensione del file sia inferiore al limite massimo consentito e riprova.',
        typeNotAllowed:
          'Non è stato possibile caricare il file. Verifica che il file sia supportato e riprova.',
      },
    },
    requiredError: 'Questo campo è obbligatorio',
  },
  notificabionHub: {
    title: 'Notifiche',
    noNotification: 'Nessuna notifica presente.',
    integrationNotReliable:
      'Il calcolo degli SLA per l\'integrazione "{{integrationName}}" non è attendibile. Il calcolo diventerà attendibile dopo 30 giorni di monitoraggio continuativo.',
  },
  sla: {
    notReliable:
      'Il calcolo degli SLA per alcune integration non è ancora attendibile, clicca qui per maggiori dettagli.',
  },
  userStatus: {
    [UserStatus.Enabled]: 'Attivo',
    [UserStatus.Pending]: 'Invitato',
    [UserStatus.Disabled]: 'Disabilitato',
  },
  charts: {
    stacked: {
      beginning: 'Iniziale:',
      intermediate: 'Intermedio:',
      advanced: 'Avanzato:',
      totalCompleted: 'Tot. persone: {{total}}',
      totalPeople: '{{total}} persone',
    },
  },
  tutorial: {
    title: 'Benvenuto su Slash',
    slides: {
      slide1: {
        title: 'Gestisci le persone della tua azienda importando le anagrafiche',
        description:
          'Nella sezione Anagrafiche puoi creare i profili delle persone della tua azienda: è il primo passo essenziale per iniziare a usare Slash, inviare gli assessment e scoprire le soft skills delle persone che lavorano con te.',
      },
      slide2: {
        title: 'Personalizza il tuo Slash',
        description:
          'Nella sezione Impostazioni, puoi personalizzare il look & feel del tuo Slash, creando un ambiente che rifletta al meglio la tua azienda e il tuo brand.',
      },
      slide3: {
        title: 'Avvia l’assessment',
        description:
          'Per iniziare il percorso di profilazione e suggerire il training più adatto a ciascun dipendente, invia l’assessment a tutta l’azienda. Trovi il questionario nella sezione Assessment.',
      },
      slide4: {
        title: 'Chiedi al tuo AI assistant',
        description:
          'Il tuo AI assistant è disponibile per rispondere alle tue domande relative alla piattaforma.',
      },
    },
    goToGuideCta: 'guida all’utilizzo',
    goToGuide: 'Visita la {{goToGuideCta}} per maggiori informazioni',
  },
  slider: {
    previous: 'Indietro',
    next: 'Avanti',
    close: 'Chiudi',
  },
  months: {
    january: 'Gennaio',
    february: 'Febbraio',
    march: 'Marzo',
    april: 'Aprile',
    may: 'Maggio',
    june: 'Giugno',
    july: 'Luglio',
    august: 'Agosto',
    september: 'Settembre',
    october: 'Ottobre',
    november: 'Novembre',
    december: 'Dicembre',
  },
  credits: {
    [EventType.SURVEY]: 'Questionario',
    [EventType.MEDIA]: 'Media',
    [EventType.RECHARGE]: 'Ricarica',
    [EventType.EXPIRATION]: 'Scadenza',
    [EventType.REWARD]: 'Ricompensa',
  },
  profileCard: {
    contentProfile: {
      profile: {
        fiscalCode: 'Codice Fiscale',
        birthDate: 'Data di Nascita',
        email: 'Email',
        jobLevel: 'Job Level',
        role: 'Ruolo Aziendale',
        department: 'Dipartimento',
        area: 'Team',
        manager: 'Responsabile',
        emailManager: 'Email Responsabile',
        statusTooltip:
          'Lo stato indica se il profilo è attivo, in sospeso, disattivo o non ancora invitato.',
        status: {
          label: 'Stato',
          [AccountStatus.ENABLED]: 'Attivo',
          [AccountStatus.DISABLED]: 'Disattivo',
          [AccountStatus.PENDING]: 'In sospeso',
          [AccountStatus.NOT_INVITED]: 'Non attivo',
        },
      },
    },
    alerts: {
      managerWrong:
        'Questo profilo non è associato a un responsabile censito. \nSoluzioni: modifica l’email, rimuovi il responsabile o crea l’anagrafica del responsabile.',
      hasIssue:
        'È stato rilevato {{count}} problema nella anagrafica. Modifica per correggerlo e assicurarti che tutte le informazioni siano aggiornate',
      hasIssues:
        'Sono state rilevate {{count}} problemi nella anagrafica. Modifica per correggerli e assicurarti che tutte le informazioni siano aggiornate',
      alertData: 'Se noti dati non corretti, contatta il team HR per aggiornarli.',
    },
    dialogs: {
      disableProfile: {
        title: 'Disattiva Profilo',
        description:
          'La disattivazione del profilo implica la cancellazione della licenza learning dell’utente con conseguente blocco di accesso di quest’ultimo alla piattaforma.\nPotrai riattivare il profilo in qualsiasi momento da questa sezione.',
        confirmation: 'Confermi di voler procedere?',
        buttons: {
          cancel: 'Annulla',
          confirm: 'Disattiva',
        },
      },
      enableProfile: {
        title: 'Attiva profilo',
        description:
          'L’attivazione del profilo implica l’assegnazione di una licenza learning all’utente con conseguente sblocco dell’accesso alla piattaforma.',
        confirmation: 'Confermi di voler procedere?',
        buttons: {
          cancel: 'Annulla',
          confirm: 'Attiva',
        },
      },
      deleteProfile: {
        title: 'Rimuovi profilo',
        description:
          'Stai rimuovendo un profilo. La rimozione del profilo implica la cancellazione della licenza learning dell’utente con conseguente blocco di accesso di quest’ultimo alla piattaforma.',
        confirmation: 'Sei sicuro di voler proseguire?',
        buttons: {
          cancel: 'Annulla',
          confirm: 'Rimuovi',
        },
        warnings: {
          departmentLosesManager:
            'Il profilo selezionato è responsabile di un dipartimento. Il dipartimento "{{departmentName}}" resterà senza responsabile.',
          departmentBecomesEmpty:
            'Il dipartimento "{{departmentName}}" resterà senza membri e verrà eliminato automaticamente.',
        },
      },
    },
    editProfile: {
      errors: {
        emailAlreadyInUse: "L'email inserita è già in uso all'interno di questa organizzazione.",
        managerError:
          'Email responsabile non riconosciuta: non esiste un profilo con questa email. Controlla di aver scritto correttamente la email oppure crea l’anagrafica del responsabile prima di procedere.',
      },
      title: 'Modifica anagrafica',
      details: 'Dettaglio profilo',
      roleInfo: 'Informazioni di ruolo',
      anagraphicDetails: 'Dettagli anagrafica',
      cta: {
        edit: 'Modifica profilo',
        disabled: 'Disattiva profilo',
        enable: 'Attiva profilo',
        remove: 'Rimuovi profilo',
      },
      fields: {
        firstName: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        emailTooltip: `L’email non può essere modificata se l'utente è già attivo. Per modificarla contattaci a ${EMAIL_SUPPORT}`,
        role: 'Ruolo Aziendale',
        department: 'Dipartimento',
        fiscalCode: 'Codice Fiscale',
        area: 'Team',
        emailManager: 'Email Responsabile',
        manager: 'Email responsabile',
        jobLevel: 'Job Level',
        birthDate: 'Data di Nascita',
        birthDatePlaceholder: 'GG/MM/AAAA',
        createDepartment: '+ Crea dipartimento',
        chooseDepartment: 'Scegli dipartimento',
        departmentPlaceholder: 'Seleziona dipartimento',
        createTeam: '+ Crea team',
        chooseTeam: 'Scegli team',
        teamPlaceholder: 'Seleziona team',
      },
      alerts: {
        emailManagerInfo:
          "Il responsabile è facoltativo. Puoi lasciare il campo vuoto oppure l'email se già censito.",
        emailManagerWrong:
          'Email non riconosciuta: non esiste un profilo con questa email. \nCorreggi l’email, rimuovi il responsabile oppure crea prima l’anagrafica del responsabile.',
      },
      buttons: {
        cancel: 'Annulla',
        save: 'Salva',
      },
      dialogs: {
        disableProfile: {
          title: 'Disattiva Profilo',
          description:
            'La disattivazione del profilo implica la cancellazione della licenza learning dell’utente con conseguente blocco di accesso di quest’ultimo alla piattaforma.\nPotrai riattivare il profilo in qualsiasi momento da questa sezione.',
          confirmation: 'Confermi di voler procedere?',
          buttons: {
            cancel: 'Annulla',
            confirm: 'Disattiva',
          },
        },
        enableProfile: {
          title: 'Attiva profilo',
          description:
            'L’attivazione del profilo implica l’assegnazione di una licenza learning all’utente con conseguente sblocco dell’accesso alla piattaforma.',
          confirmation: 'Confermi di voler procedere?',
          buttons: {
            cancel: 'Annulla',
            confirm: 'Attiva',
          },
        },
      },
    },
  },
  surveysShared: {
    recapAssessment: {
      overview: {
        completed: 'Questionari completati',
        invited: 'Questionari inviati',
        toComplete: 'Questionari da completare',
        completionRate: 'Tasso di completamento',
        linkAssessment: 'Vai a Assessment',
        info: 'Non sono ancora presenti risultati: la dashboard sarà visibile solo quando sarà raccolta almeno una risposta',
        infoWithName:
          'Non sono ancora presenti risultati per {{templateName}}: la dashboard sarà visibile solo quando sarà raccolta almeno una risposta',
      },
    },
  },
  sharedComponents: {
    readMoreTypography: {
      readMoreLabel: 'Leggi di più',
      readLessLabel: 'Leggi di meno',
    },
  },
  ...loginLocales,
  ...dashboardLocales,
  ...settingsLocales,
  ...maintenanceModeLocales,
  ...paymentsLocales,
  ...configurationLocales,
  ...peopleLocales,
  ...surveysLocales,
  ...departmentsLocales,
  ...aiPlaygroundLocales,
  ...trainingHardSkillsLocales,
  ...trainingSoftSkillsLocales,
  ...profileLocales,
  ...creditsLocales,
  ...departmentLocales,
  ...conversationLocales,
  ...quizLocales,
  ...videoLocales,
  ...documentLocales,
  ...assessmentsLocales,
  ...reportsLocales,
  ...invitationLocales,
  ...coreLocales,
  ...billingLocales,
};
